import Vue from "vue";
import Vuex from "vuex";

// import firebase from 'firebase'

import localData from "./static/acciones.json";

// firebase parser
import FireStoreParser from "firestore-parser";
import axios from "axios";

const web = "kutxabank.cms";
const LANG_URL =
  "https://firestore.googleapis.com/v1/projects/cmsfrontend-d17fc/databases/(default)/documents/lang/idiomas";

// Firebase Cliente
// const layoutRef = db.collection('webs').doc(web)
// const vinculadosRef = db.collection('vinculados')

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    layout: [],
    Recomendados: {},
    Slider: {},
    Top5: {},
    cargando: true,
    detalleEvento: null,
    Menu: [],
    menuMovil: false,
    eventosWeb: localData.eventos,
    eventosPagina: [],
    musicales: [],
    eventoBuscador: null,
    eventosScroll: [],
    contenidoIdioma: {},
    Hoy: new Date(),
    ahora: null,
    recintosJanto: {},
    recintosWeb: null,
    listaschopenhauer: {},
    contenidoEnlace: null,
    banners: [],
    eventosJanto: {},
    itemsWeb: [],
    webLoaded: false,
  },
  mutations: {
    setMenuMovil(state, payload) {
      state.menuMovil = payload;
    },
    setEventosWeb(state, payload) {
      // console.log('Weventos wev', payload)
      state.eventosWeb = payload;
    },
    setLayout(state, payload) {
      // console.log('store layout', payload.secciones.menu)
      const pageLayout = payload.pageLayout;
      const secciones = payload.secciones;
      state.layout = payload;
      // state.Slider = payload.secciones["adminSlider"];
      // state.Recomendados = payload.secciones["adminRecomendados"];
      // state.Top5 = payload.secciones["top5"];
      // state.Menu = payload.secciones["menu"];
      state.Slider = secciones[pageLayout[0]];
      state.Recomendados = secciones[pageLayout[1]];
      state.Top5 = secciones[pageLayout[2]];
      state.Menu = secciones[pageLayout[3]];
    },
    setCargando(state, payload) {
      state.cargando = payload;
    },
    setDetalle(state, payload) {
      state.detalleEvento = payload;
    },
    setEventosPagina(state, payload) {
      state.eventosPagina = payload;
    },
    setEventoBuscador(state, payload) {
      // console.log('evento Buscador', payload)
      state.eventoBuscador = payload;
    },
    setEventosScroll(state, payload) {
      state.eventosScroll = payload;
    },
    setHoy(state, payload) {
      state.Hoy = payload;
    },
    setContenidoIdioma(state, payload) {
      state.contenidoIdioma = payload;
    },
    ahora(state, payload) {
      state.ahora = payload;
    },
    setRecintosJanto(state, payload) {
    // console.log('recintos Janto', payload)
      state.recintosJanto = payload;
    },
    setRecintosWeb(state, payload) {
      state.recintosWeb = payload;
    },
    setContenidoEnlace(state, payload) {
      state.contenidoEnlace = payload;
    },
    SET_SCHOPENHAUER(state, payload) {
      state.listaschopenhauer = payload;
    },
    setBanners(state, payload) {
      state.banners = payload;
    },
    setEventosJanto(state, payload) {
      state.eventosJanto = payload;
    },
    setWebLoaded(state, payload) {
      state.webLoaded = payload;
    },
    setItemsWeb(state, payload) {
      state.itemsWeb = payload;
    },
  },
  actions: {
    getRestApi: ({ commit, dispatch }, webData) => {
      const Hoy = new Date();
      commit("setHoy", Hoy);
    // console.log("conectado REST");

      commit("setCargando", false);
      if (webData) {
        const mesActual = Hoy.getMonth() + 1;
        const diaActual = Hoy.getDate();

        const year = Hoy.getFullYear();
        const mes = ("0" + mesActual).slice(-2);
        const dia = ("0" + diaActual).slice(-2);
        const hora = ("0" + Hoy.getHours()).slice(-2);
        const minutos = ("0" + Hoy.getMinutes()).slice(-2);

        const ahora = year + mes + dia + hora + minutos;

        const eventosActivos = webData.eventos.filter(
          e => e.FFinVentaMax > ahora
        );

        const listaEventosUnicos = {};
        const eventosActivosUnicos = [];

      // console.log("conectado REST", eventosActivos.length);

        eventosActivos.forEach(evento => {
          const webId = evento.cmsID + "__" + evento.Recinto[0].Id;
          if (!evento.hasOwnProperty("webId")) {
            evento.webId = webId;
          }

          if (!listaEventosUnicos[webId]) {
            listaEventosUnicos[webId] = evento;
            eventosActivosUnicos.push(listaEventosUnicos[webId]);
          } else {
            // console.log('repetido', evento.Nombre, evento.webId )
          }
        });

        webData.eventos = eventosActivosUnicos;
        // console.log('Eventos Pasados', webData.eventos.filter(e=>e.FFinVentaMax<ahora), 'actuales',eventosActivos.length,  'Ahora', ahora)
        // console.log('Version', 'Recintos')
        commit("setEventosWeb", eventosActivosUnicos);
        commit("setLayout", webData);
        commit("ahora", ahora);

        //get recintos
      // console.log("getRcintos Store");
        dispatch("getRecintos");
        dispatch("GET_SCHOPENHAUER");
        // dispatch('getBanners')
      }
    },
    getLang: ({ commit }, datos) => {
      // commit('setCargando',true)
      commit("setContenidoIdioma", {});
      const langUrl = `${LANG_URL}/${datos.idioma}/${datos.id}`;
      axios
        .get(langUrl)
        .then(res => FireStoreParser(res.data))
        .then(json => {
          commit("setCargando", false);
          const contenidoIdioma = json.fields ? json.fields : {};
          // console.log('axios', contenidoIdioma)
          commit("setContenidoIdioma", contenidoIdioma);
          // if (doc.exists) {
          //   contenidoIdioma = doc.data()
          //   commit('setContenidoIdioma', contenidoIdioma)
          // } else {
          // // console.log('no existe idoma: ', datos.idioma)
          //   commit('setContenidoIdioma', contenidoIdioma)
          // }
        })
        .catch(err => console.error(err));
    },
    getRecintos: ({ commit, state, dispatch }) => {
      const allEvents = state.eventosWeb;
      const misRecintos = {};
      allEvents.forEach(a => {
        let recinto = a.Recinto[0];
        let idRecinto = recinto.Id + "@" + a.Instalacion;
        if (!misRecintos.hasOwnProperty(idRecinto)) {
          let eventos = [];
          recinto.Host = a.Host;
          recinto.Provincia = a.Provincia[0];
          recinto.Poblacion = a.Poblacion[0];
          recinto.Instalacion = a.Instalacion;
          recinto.idRecinto = idRecinto;
          recinto.CP = a.CP;

          misRecintos[idRecinto] = {
            recinto,
            eventos,
          };
        }
        misRecintos[idRecinto].eventos.push(a);
      });

      // commit("setRecintosJanto", misRecintos);
    },
    GET_SCHOPENHAUER({ commit, state }) {
      // console.log('get schopenhauer')

      const url = `https://firestore.googleapis.com/v1beta1/projects/cmsfrontend-d17fc/databases/(default)/documents/webs/${web}:runQuery`;
      const query = {
        structuredQuery: {
          from: [{ collectionId: "schopenhauer" }],
          orderBy: [
            {
              field: {
                fieldPath: "id",
              },
              direction: "ASCENDING",
            },
          ],
          select: {
            fields: [
              { fieldPath: "id" },
              { fieldPath: "nombre" },
              { fieldPath: "tipo" },
              { fieldPath: "imageUrl" },
              { fieldPath: "destino" },
              { fieldPath: "slug" },
              { fieldPath: "datos" },
            ],
          },
        },
      };
      axios
        .post(url, query)
        .then(res => FireStoreParser(res.data))
        .then(json => {
          const datos = {};
          const banners = [];
          const webData = json;

          webData.forEach(
            item => (datos[item.document.fields.id] = item.document.fields)
          );
          // console.log('todos datos', webData)
          commit("SET_SCHOPENHAUER", datos);
        });
    },
    getContenidoEnlace({ commit, state }, idContenidoEnlace) {
      // console.log("getContenidoEnlace");
      const url = `https://firestore.googleapis.com/v1beta1/projects/cmsfrontend-d17fc/databases/(default)/documents/webs/${web}/schopenhauer/${idContenidoEnlace}`;
      axios
        .get(url)
        .then(res => FireStoreParser(res.data))
        .then(json => {
          // console.log("axios", json.fields);
          const webData = json.fields;
          commit("setContenidoEnlace", webData);
        });
    },
    getBanners({ commit }) {
    // console.log("get Banners");
      const url = `https://firestore.googleapis.com/v1beta1/projects/cmsfrontend-d17fc/databases/(default)/documents/webs/${web}/banners`;

      axios
        .get(url)
        .then(res => FireStoreParser(res.data))
        .then(json => {
          const webData = json.documents;
          const banners = [];

          webData.forEach(item => banners.push(item.fields));
          commit("setBanners", banners);

          // console.log('axios', banners)
        });
    },

    // getLayout: ({commit}, web)=>{
    //   const Hoy = new Date()
    //   commit('setHoy', Hoy)
    //   commit('setCargando', true)

    //   layoutRef.get().then(doc=>{

    //     commit('setCargando', false)
    //     if (doc.exists) {

    //       const mesActual = Hoy.getMonth() + 1
    //       const diaActual = Hoy.getDate()

    //       const year = Hoy.getFullYear()
    //       const mes = ('0' + mesActual).slice(-2)
    //       const dia = ('0' + diaActual).slice(-2)
    //       const hora = ('0' + Hoy.getHours()).slice(-2)
    //       const minutos = ('0' + Hoy.getMinutes()).slice(-2)

    //       const ahora =  year + mes + dia + hora + minutos

    //       const eventosActivos = doc.data().eventos.filter(e=>e.FFinVentaMax>ahora)

    //  // -- console.log('Eventos Pasados', doc.data().eventos.filter(e=>e.FFinVentaMax<ahora), 'actuales',eventosActivos.length,  'Ahora', ahora)
    //       commit('setEventosWeb', eventosActivos)
    //       commit('setLayout', doc.data())
    //       }
    //     }).catch(err=>console.log(err))

    // },
    // getDetalle: ({commit, state}, cmsID)=>{
    //   commit('setCargando', true)
    //   const evento = state.eventosWeb.find(e=>e.cmsID==cmsID)
    //   // console.log('evento Existe', evento)
    //   const detalleDoc = vinculadosRef.doc(cmsID)
    //   detalleDoc.get().then(doc=>{
    //     commit('setCargando', false)
    //     // console.log('buscando', doc)
    //     if (doc.exists) {
    //       commit('setDetalle', doc.data())

    //     }
    //   }).catch(err=>console.log(err))
    // }
  },
});
